import { paymentOptions } from '../../../../../const/paymentOptions';
import isDCHCustomerAssistancePlanEnrolled from '../../../../../helpers/isDCHCustomerAssistancePlanEnrolled';
import isDCHDelinquent from '../../../../../helpers/isDCHDelinquent';
import { t } from '../../../../../strings/i18n';
const getOneTimePaymentAmountHelpText = (productType, accountSummary, paymentOption, featureFlags) => {
    const shouldDisplayHelpTextForPaymentAmount = paymentOption === paymentOptions.PAST_DUE;
    if ((isDCHCustomerAssistancePlanEnrolled(accountSummary.billing, productType, featureFlags) ||
        isDCHDelinquent(accountSummary.billing, productType, featureFlags)) &&
        shouldDisplayHelpTextForPaymentAmount) {
        return t('paymentAmountOptionSubText.dchEligiblePastDueOption');
    }
    return '';
};
export default getOneTimePaymentAmountHelpText;
